import React from "react";
import ReactMultiSelectCheckboxes from "react-multiselect-checkboxes";

const CustomSelect = ({ name, options = [], value = [], isMulti = true, placeholder = "Select...", onChange }) => {
    const selected = value || [];
    const allSelected = isMulti && options.length > 0 && selected.length === options.length;

    const handleChange = v => {
        if (!isMulti) {
            onChange(v?.length ? v[v.length - 1] : null, name);
            return;
        }
        onChange(v || [], name);
    };

    const handleSelectAll = e => {
        e.stopPropagation();
        onChange(allSelected ? [] : [...options], name);
    };

    const CustomOption = ({ data, isSelected, innerRef, innerProps }) => (
        <div
            ref={innerRef}
            {...innerProps}
            style={{ display: "flex", alignItems: "center", padding: "8px 12px", cursor: "pointer" }}
        >
            <input type="checkbox" checked={isSelected} readOnly style={{ marginRight: 8 }} />
            <span>{data.label}</span>
        </div>
    );

    const SelectAll = () => isMulti && (
        <div
            onMouseDown={e => { e.preventDefault(); e.stopPropagation(); }}
            onClick={handleSelectAll}
            style={{
                display: "flex",
                alignItems: "center",
                padding: "8px 12px",
                cursor: "pointer",
                borderBottom: "1px solid #eee",
                fontWeight: 500
            }}
        >
            <input type="checkbox" checked={allSelected} readOnly style={{ marginRight: 8 }} />
            <span>Select All</span>
        </div>
    );

    return (
        <div>
            <label className="form-label_bus text-capitalize">{name}</label>

            <ReactMultiSelectCheckboxes
                options={options}
                value={selected}
                onChange={handleChange}
                isMulti={true}
                closeMenuOnSelect={false}
                hideSelectedOptions={false}
                placeholderButtonLabel={placeholder}
                components={{
                    Option: CustomOption,
                    MenuList: props => (
                        <div
                            style={{
                                background: "#fff",
                                border: "1px solid #e5e7eb",
                                borderRadius: 6,
                                boxShadow: "0 3px 10px rgba(0,0,0,.08)",
                                overflow: "hidden"
                            }}
                        >
                            <SelectAll />
                            <div style={{ maxHeight: 180, overflowY: "auto" }}>
                                {props.children}
                            </div>
                        </div>
                    )
                }}
            />
        </div>
    );
};

export default CustomSelect;